import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[truncate-breadcrumb]',
})
export class TruncateBreadcrumbDirective {
  constructor(private el: ElementRef) {}

  public ngDoCheck(): void {
    this.verifyGroupAutoCompleteOptionWidth();
  }

  private verifyGroupAutoCompleteOptionWidth(): void {
    if (this.el.nativeElement.clientWidth < this.el.nativeElement.scrollWidth) {
      this.el.nativeElement.classList.add('truncate-breadcrumb');
    }
  }
}
